import React from 'react';
import '../index.css';
import './manifesto.css';
import '../output.css';
import { TypeAnimation } from 'react-type-animation';

import ScrollWipe from './scrollwiper'
import WideYork from "../assets/images/widenychart.png"; // Adjust the path if needed

import { useState, useEffect } from 'react';
import { useRef, useLayoutEffect } from "react";

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

function useFitToWidth(ref, { min = 44, max = 140 } = {}) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (el.tagName !== "H1") return;

    const fit = () => {
      // only do this on desktop-ish screens
      if (window.innerWidth < 769) {
        el.style.fontSize = ""; // let CSS/mobile rules take over
        return;
      }

      const available = el.getBoundingClientRect().width;
      if (!available) return;

      // Binary search for largest font-size that fits on one line
      let lo = min, hi = max, best = min;

      while (lo <= hi) {
        const mid = (lo + hi) >> 1;
        el.style.fontSize = `${mid}px`;

        // If it overflows, scrollWidth > available
        if (el.scrollWidth <= available) {
          best = mid;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }

      el.style.fontSize = `${best}px`;
    };

    const run = () => requestAnimationFrame(fit);

    // Wait for fonts so metrics aren't garbage
    let cancelled = false;
    const start = async () => {
      if (document.fonts?.ready) await document.fonts.ready;
      if (cancelled) return;
      run();
    };
    start();

    const ro = new ResizeObserver(run);
    ro.observe(el);
    window.addEventListener("resize", run);

    return () => {
      cancelled = true;
      ro.disconnect();
      window.removeEventListener("resize", run);
    };
  }, [ref, min, max]);
}



export default function ModifiedMission(){

  const isMobile = useIsMobile();

  const h1Ref = useRef(null);
  const h2Ref = useRef(null);

//  const titleRef = useRef(null);
//  const conclusionRef = useRef(null);

  useFitToWidth(h1Ref, { min: 56, max: 120 });
  useFitToWidth(h2Ref, { min: 56, max: 120 });




  if (isMobile) {
    return (
      <section className="hero">
        <div className="hero__inner">
          <h1 ref={h1Ref} className="hero__title">The banks are stealing from you.</h1>

          <ScrollWipe as="p" className="hero__lede">
            The modern economy is built on a scam. You were taught to trust banks: to park your money in savings, let it compound, build a "future." You were told it would magically compound itself into generational wealth. While they generously give you 0.1% APY, the banks are earning 7%, 8%, 9% interest with your money. They get the bread while you get the crumbs. This is theft.
          </ScrollWipe>
          <ScrollWipe as="p" className="hero__rede">
            If you are familiar with deposit banking, then you know the model of a bank is something like this: a bank takes your money and lends it out to Bobby for 7% interest. As a reward, the bank pays you 0.1% interest. The bank used your money and kept 90% of the profits. That's not very fair. But what if we could get rid of the bank?
          </ScrollWipe>
          <ScrollWipe className="hero__lede">
            This is the foundational idea behind commonwealth. If you could eliminate the middleman, Bobby could pay a lower interest rate while you earn higher yields. Instead of Bobby paying 7% to a bank that pays you 0.1%, Bobby could just pay you 4%. That's a win-win for you and Bobby. That's exactly what we're building at commonwealth. A trustless, peer-to-peer lending market so that you never have to use a bank again.
          </ScrollWipe>
          <h1 ref={h2Ref} className="hero__conclusion">
            Commonwealth is here to kill banks.
          </h1>
        </div>
      </section>
    )
  } else {
    return (
      <section className="hero">
        <div className="hero__inner">
          <h1 ref={h1Ref} className="hero__title">The banks are stealing from you.</h1>

          <ScrollWipe as="p" className="hero__lede">
            The modern economy is built on a scam. You were taught to trust banks: to park your money in savings, let it compound, build a "future." You were told it would magically compound itself into generational wealth. While they generously give you 0.1% APY, the banks are earning 7%, 8%, 9% interest with your money. They get the bread while you get the crumbs. This is theft.
          </ScrollWipe>
          <ScrollWipe as="p" className="hero__rede">
            If you are familiar with deposit banking, then you know the model of a bank is something like this: a bank takes your money and lends it out to Bobby for 7% interest. As a reward, the bank pays you 0.1% interest. The bank used your money and kept 90% of the profits. That's not very fair. But what if we could get rid of the bank?
          </ScrollWipe>
          <ScrollWipe className="hero__lede">
            This is the foundational idea behind commonwealth. If you could eliminate the middleman, Bobby could pay a lower interest rate while you earn higher yields. Instead of Bobby paying 7% to a bank that pays you 0.1%, Bobby could just pay you 4%. That's a win-win for you and Bobby. That's exactly what we're building at commonwealth. A trustless, peer-to-peer lending market so that you never have to use a bank again.
          </ScrollWipe>
          <h1 ref={h2Ref} className="hero__conclusion">
            Commonwealth is here to kill banks.
          </h1>
        </div>
      </section>
    );
  }
}
